import axios from 'axios';
import { getSessionToken } from '@shopify/app-bridge/utilities';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
});

let appBridgeInstance = null;

/**
 * Set App Bridge instance for session token retrieval
 * Called by AppBridgeProvider when App Bridge is initialized
 */
export const setAppBridgeInstance = (instance) => {
  appBridgeInstance = instance;
};

/**
 * Axios request interceptor to add authentication token
 * Supports both Shopify session tokens (embedded) and custom JWT (standalone)
 */
apiClient.interceptors.request.use(
  async (config) => {
    try {
      // Check if we have App Bridge (embedded mode)
      if (appBridgeInstance) {
        // Get Shopify session token
        const sessionToken = await getSessionToken(appBridgeInstance);
        config.headers['Authorization'] = `Bearer ${sessionToken}`;
      } else {
        // Standalone mode - use JWT from localStorage
        const token = localStorage.getItem('shopify_token');
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error('Failed to add auth token:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor for error handling
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - handle logout
      console.error('Authentication failed:', error);
      // Don't automatically redirect in embedded mode
      if (!appBridgeInstance) {
        localStorage.removeItem('shopify_token');
        localStorage.removeItem('shop_domain');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
